import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import Container from './css';
import {
  SummaryTitle,
  Table,
  TableTitle,
  TableCell,
  InlineTableCell,
  CellLabel,
  CellValue,
} from '../css';

const ShipmentSummary = ({ data }) => {
  const { shipperDetails, consigneeDetails } = data;

  return (
    <Container>
      <SummaryTitle>{t('ShipmentSummary')}</SummaryTitle>

      <Table>
        <TableTitle>{t('ShipperDetailsTitle')}</TableTitle>
        <TableCell>
          <CellLabel>{t('ContactName')}</CellLabel>
          <CellValue>{shipperDetails.contactName}</CellValue>
        </TableCell>
        <TableCell>
          <CellLabel>{t('Company')}</CellLabel>
          <CellValue>{shipperDetails.companyName}</CellValue>
        </TableCell>
        <TableCell>
          <CellLabel>{t('Address')}</CellLabel>
          <CellValue>
            {/* eslint-disable-next-line max-len */}
            {shipperDetails.address1}
            ,
            {shipperDetails.city}
            ,
            {shipperDetails.provinceCode}
            {' '}
            {shipperDetails.postalCode}
            ,
            {' '}
            {shipperDetails.countryCode}
          </CellValue>
        </TableCell>
        <TableCell>
          <CellLabel>{t('AdditionalAddress')}</CellLabel>
          <CellValue>{shipperDetails.address2 || '-'}</CellValue>
        </TableCell>
        <TableCell>
          <CellLabel>{t('IsResidentialAddress')}</CellLabel>
          <CellValue>{shipperDetails.isResidential ? t('Yes') : t('No')}</CellValue>
        </TableCell>
        <TableCell>
          <CellLabel>{t('Email')}</CellLabel>
          <CellValue>{shipperDetails.contactEmail}</CellValue>
        </TableCell>
        <TableCell>
          <CellLabel>{t('PhoneNumber')}</CellLabel>
          <CellValue>{shipperDetails.contactPhoneNumber}</CellValue>
        </TableCell>
        <TableCell>
          <CellLabel>{t('Extension')}</CellLabel>
          <CellValue>{shipperDetails.contactPhoneNumberExtension || '-'}</CellValue>
        </TableCell>
        <TableCell>
          <CellLabel>{t('MobileForSMSNotifications')}</CellLabel>
          <CellValue>{shipperDetails.cell || '-'}</CellValue>
        </TableCell>
      </Table>

      <Table>
        <TableTitle>{t('ConsigneeDetailsTitle')}</TableTitle>
        <TableCell>
          <CellLabel>{t('ContactName')}</CellLabel>
          <CellValue>{consigneeDetails.contactName}</CellValue>
        </TableCell>
        <TableCell>
          <CellLabel>{t('Company')}</CellLabel>
          <CellValue>{consigneeDetails.companyName}</CellValue>
        </TableCell>
        <TableCell>
          <CellLabel>{t('Address')}</CellLabel>
          <CellValue>
            {/* eslint-disable-next-line max-len */}
            {consigneeDetails.address1}
            ,
            {consigneeDetails.city}
            ,
            {consigneeDetails.provinceCode}
            {' '}
            {consigneeDetails.postalCode}
            ,
            {' '}
            {consigneeDetails.countryCode}
          </CellValue>
        </TableCell>
        <TableCell>
          <CellLabel>{t('AdditionalAddress')}</CellLabel>
          <CellValue>{consigneeDetails.address2 || '-'}</CellValue>
        </TableCell>
        <TableCell>
          <CellLabel>{t('IsResidentialAddress')}</CellLabel>
          <CellValue>{consigneeDetails.isResidential ? t('Yes') : t('No')}</CellValue>
        </TableCell>
        <TableCell>
          <CellLabel>{t('Email')}</CellLabel>
          <CellValue>{consigneeDetails.contactEmail}</CellValue>
        </TableCell>
        <TableCell>
          <CellLabel>{t('PhoneNumber')}</CellLabel>
          <CellValue>{consigneeDetails.contactPhoneNumber}</CellValue>
        </TableCell>
        <TableCell>
          <CellLabel>{t('Extension')}</CellLabel>
          <CellValue>{consigneeDetails.contactPhoneNumberExtension || '-'}</CellValue>
        </TableCell>
        <TableCell>
          <CellLabel>{t('MobileForSMSNotifications')}</CellLabel>
          <CellValue>{consigneeDetails.cell || '-'}</CellValue>
        </TableCell>
      </Table>

      <Table>
        <TableTitle>{t('CustomsBrokerDetails')}</TableTitle>
        <TableCell>
          <CellLabel>{t('ContactName')}</CellLabel>
          <CellValue>{data.brokerName}</CellValue>
        </TableCell>
        <TableCell>
          <CellLabel>{t('Email')}</CellLabel>
          <CellValue>{data.brokerEmail}</CellValue>
        </TableCell>
        <TableCell>
          <CellLabel>{t('PhoneNumber')}</CellLabel>
          <CellValue>{data.brokerPhoneNumber}</CellValue>
        </TableCell>
      </Table>

      <Table>
        <TableTitle>{t('BillingInformation')}</TableTitle>
        <InlineTableCell>
          <CellLabel>{t('BillTo')}</CellLabel>
          <CellValue>{data.billToAccountNumber}</CellValue>
        </InlineTableCell>
      </Table>
    </Container>
  );
};

ShipmentSummary.propTypes = {
  data: PropTypes.shape({
    shipperDetails: PropTypes.shape({
      contactName: PropTypes.string,
      companyName: PropTypes.string,
      address1: PropTypes.string,
      city: PropTypes.string,
      provinceCode: PropTypes.string,
      postalCode: PropTypes.string,
      countryCode: PropTypes.string,
      address2: PropTypes.string,
      isResidential: PropTypes.bool,
      contactEmail: PropTypes.string,
      contactPhoneNumber: PropTypes.string,
      contactPhoneNumberExtension: PropTypes.string,
      cell: PropTypes.string,
    }),
    consigneeDetails: PropTypes.shape({
      contactName: PropTypes.string,
      companyName: PropTypes.string,
      address1: PropTypes.string,
      city: PropTypes.string,
      provinceCode: PropTypes.string,
      postalCode: PropTypes.string,
      countryCode: PropTypes.string,
      address2: PropTypes.string,
      isResidential: PropTypes.bool,
      contactEmail: PropTypes.string,
      contactPhoneNumber: PropTypes.string,
      contactPhoneNumberExtension: PropTypes.string,
      cell: PropTypes.string,
    }),
    brokerName: PropTypes.string,
    brokerEmail: PropTypes.string,
    brokerPhoneNumber: PropTypes.string,
    billToAccountNumber: PropTypes.string,
  }),
};

export default ShipmentSummary;
